import { createSlice } from '@reduxjs/toolkit';
import { AnalyticsManagementState } from './types';

export const initialState: AnalyticsManagementState = {
  token: '',
  loading: false,
  error: '',
  businessGroupList: [],
  engagement: {
    uniqueUsers: { value: 0, change: 0 },
    pageViews: { value: 0, change: 0 },
    videoViews: { value: 0, change: 0 },
    avgSessionTime: { value: 0, change: 0 },
    totalWatchTime: { value: 0, change: 0 },
    bounceRate: { value: 0, change: 0 },
    engagementOverTime: [],
    engagementFunnel: {},
    interactions: {},
    countries: [],
    devices: [],
    os: [],
    browser: []
  }
};

const localeSlice = createSlice({
  name: 'AnalyticsManagement',
  initialState,
  reducers: {
    fetchToken: (state, action) => {
      state.loading = true;
      state.error = '';
    },
    fetchTokenSuccess: (state, action) => {
      state.loading = false;
      state.token = action.payload;
    },
    fetchTokenFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    fetchBusinessGroup: (state, action) => {
      state.loading = true;
      state.error = '';
    },
    fetchBusinessGroupSuccess: (state, action) => {
      state.loading = false;
      state.businessGroupList = action.payload;
    },
    fetchBusinessGroupFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    fetchEngagementWidgetData: (state, action) => {
      state.loading = true;
      state.error = '';
    },
    fetchEngagementWidgetDataSuccess: (state, action) => {
      state.loading = false;
      state.engagement = {
        ...state.engagement,
        [action.payload.key]: action.payload.data
      };
      // if (action.payload.key === 'engagementOverTime') {
      //   state.engagement = {
      //     ...state.engagement,
      //     [action.payload.key]: action.payload.data
      //   };
      // } else {
      //   state.engagement = {
      //     ...state.engagement,
      //     // [action.payload.key]: {
      //     //   value: action.payload.data.current,
      //     //   change: action.payload.data.percentChange
      //     // }
      //     [action.payload.key]: action.payload.data
      //   };
      // }
    },
    fetchEngagementWidgetDataFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    resetState: () => {
      return initialState;
    }
  }
});

export const {
  fetchToken,
  fetchTokenSuccess,
  fetchTokenFailure,
  fetchBusinessGroup,
  fetchBusinessGroupSuccess,
  fetchBusinessGroupFailure,
  fetchEngagementWidgetData,
  fetchEngagementWidgetDataSuccess,
  fetchEngagementWidgetDataFailure,
  resetState
} = localeSlice.actions;

export default localeSlice.reducer;
